export const particleOption = {
    background: {
        color: {
            value: "#b78628",
        },
    },
    fpsLimit: 12000,
    interactivity: {
        events: {
            onClick: {
                enable: false,
                mode: "push",
            },
            onHover: {
                enable: false,
                mode: "repulse",
            },
            resize: true,
        },
        modes: {
            bubble: {
                distance: 2000,
                duration: 50,
                opacity: 0.1,
                size: 40,
            },
            push: {
                quantity: 1,
            },
            repulse: {
                distance: 200,
                duration: 30,
            },
        },
    },
    particles: {
        color: {
            value: "#000000",
        },
        links: {
            color: "#ffffff",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
        },
        collisions: {
            enable: false,
        },
        move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 0.4,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 800,
            },
            value: 80,
        },
        opacity: {
            value: 0.5,
        },
        shape: {
            type: "circle",
        },
        size: {
            random: true,
            value: 5,
        },
    },
    detectRetina: true,
};